export enum Languages {
  da = 1,
  en = 2,
}

export enum widgetConfigKeys {
  notBroadcast = 'notBroadcast',
  hideChannelLinks = 'hideChannelLinks',
  enableTabLinks = 'enableTabLinks',
  enableHashEventId = 'enableHashEventId',
  enableWidgetContent = 'enableWidgetContent',
}

export interface ISport {
  id: number;
  name: string;
  trName: string;
  logoUrl?: string;
  nameShort?: string;
  isHeadToHead?: IIsHeadToHead;
}

export interface ICompetition {
  id: number;
  sportId: number;
  regionId: number;
  parentId: null | number;
  name: string;
  gender: string;
  trName: string;
  sport?: ISport;
  region?: IRegion;
  widgetCompetition?: IWidgetCompetition;
  additionalName?: string | null;
}

export interface ICompetitor {
  id: number;
  sportId: number;
  regionId: number;
  sourceId: number;
  name: string;
  gender: string;
  competitorType: string;
  isNationalTeam: boolean;
  regionName: string;
  nameCode: string | null;
  region: IRegion;
  logoUrl: null | string;
  translations?: ITranslation[];
  trName: string;
  firstName: null | string;
  lastName: null | string;
  properties?: ICompetitorProperty[];
  sport?: ISport;
  customName: string | null;
}

export interface ICompetitorProperty {
  id: number;
  competitorId: number;
  type: string;
  value: string;
}

export interface IProvider {
  id: number;
  name: string;
  logoUrl?: string;
  lightLogoUrl?: string;
  squareLogoUrl?: string;
  slug: string;
  deals?: IDeal[];
  themeColor?: string | null;
}

export interface IDeal {
  id: number;
  providerId: number;
  regionId: number;
  dealText: string;
}

export interface IOutcome {
  id: number;
  name: string;
}

export interface IRegion {
  id: number;
  name: string;
  trName: string;
  name_short?: string;
  isContinent?: number; //is 0 or 1 , boolean in number type
}

export interface IWidget {
  id: number,
  widgetTypeId: number,
  clientId: number,
  userId: number,
  languageId: number,
  name: string,
  status: string,
  theme: string,
  oddsFormat: oddsFormats,
  outLinkFolder?: string | null,
  providerLogoTemplate: string,
  providerLogoType: string,
  clickableRows: boolean,
  showTeamLogos: boolean,
  linkTemplate: string | null,
  format: string
}

export interface IWidgetCompetition {
  competitionId: number;
  priority: number;
  shortName: string | null;
  widgetId: number;
  competition: any;
}

export interface IObjectStyle {
  type: string;
  value: string;
}

export interface IStatesArr {
  stateIso2Code: string | null;
  states: ICountryState[] | null;
}

export interface ICountryState {
  id: number;
  name: string;
  iso2: string;
}

export interface IIncident {
  id: number;
  competitor?: {
    trShortName: string;
    trName: string;
    id: number;
  };
  elapsed: string;
  name: string;
}

export interface IOtherOdds {
  outcome_name: string;
  odds: null | number;
  provider: IProvider;
}

export interface IMaxOdd extends IOdds {
  startOdds: number | null;
  outcomeName: string;
  otherOdds: IOtherOdds[],
  line: string | number | null;
  oddsChange?: string;
}

export interface IWidgetProvider {
  priority: number;
  providerId: number;
  provider: IProvider;
  widgetId: number;
  outLink: string|null;
}

export interface IOddsGroup {
  provider: IProvider;
  odds: number;
}

export interface ITournamentStage {
  id: number;
  name: string;
  tournamentId: number;
  gender: string;
  regionId: number;
  startTime: string;
  endTime: string;
  tournament: ITournament;
}

export interface ITournament {
  id: number;
  name: string;
  competitionId: number;
  exId: number;
  competition: ICompetition;
}

export interface IMatchStatistic {
  label: string | null;
  value: number | null;
  code: string;
}

export interface IEventCompetitor {
  id: number;
  eventId: number;
  competitorId: number;
  position: EventPositions | number;
  competitor?: ICompetitor;
  results?: IResult[];
  prevMeetings?: IPrevEvent[];
  statistics?: IMatchStatistic[];
}

export interface IPrevEvent extends IEvent {
  score: number[];
  aet: boolean;
  penalties: null | number[];
  meetingResult: MeetingResult;
}

export interface IFeaturedEvent extends IEvent {
  channelsInfo: IChannel[];
  eventCompetitors: IEventCompetitor[];
  maxOdds: IMaxOdd[];
  maxOddsMarketId: number | null;
  tournamentStage: ITournamentStage;
  tournamentStageId: number;
}

export enum MeetingResult {
  Win = "win",
  Loss = "loss",
  Draw = "draw",
}

export enum EventStatus {
  NotStarted = "notstarted",
  Inprogress = "inprogress",
  Finished = "finished",
  Interrupted = "interrupted",
  Cancelled = "cancelled",
  Postponed = "postponed",
  Unknown = "unknown",
  Deleted = "deleted",
}

export enum IncidentNames {
  GOAL = 'Goal',
  OWN_GOAL = 'Own Goal',
  ETRATIME_OWN_GOAL= 'Extratime own goal',
  SUBSTITUTION_IN = 'Substitution In',
  SUBSTITUTION_OUT= 'Substitution Out',
  GAME_STARTED = 'GameStarted',
  FIRST_HALF_ENDED = 'FirstHalfEnded',
  SECOND_HALF_STARTED = 'SecondHalfStarted',
  SECOND_HALF_ENDED = 'SecondHalfEnded',
  PENALTY = 'Penalty',
  GOAL_PENALTY = 'GoalPenalty',
  EXTRATIME_PENALTY_SCORED = 'Extratime penalty scored',
  YELLOW_CARD = 'Yellow Card',
  SECOND_YELLOW_CARD = 'Yellow Card 2',
  RED_CARD = 'Red Card',
}

export interface ITranslation {
  id: number;
  type: string;
  fkId: number;
  languageId: number;
  value: string;
  slug: string;
  manual: string;
}

export interface IResult {
  id: number;
  eventCompetitorId: number;
  periodId: number;
  result: string;
}

export interface IEventProperty {
  id: number;
  eventId: number;
  type: string;
  value: string;
}

export interface IWidgetMeta {
  type: string;
  value: string;
}

export interface IBuilderComponentGroup {
  id: number;
  widget_type_id: number;
  name: string;
  slug: BuilderComponentGroupSlug;
  widgetBuilderComponent: IWidgetBuilderComponent[];
}

export interface IWidgetBuilderComponent {
  id: number;
  widgetId: number;
  builderComponent: IBuilderComponent;
  builderComponentGroupId: number | null;
  builderComponentId: number;
  position: number;
  customName: string | null;
  widgetBanner: IBannerAd | null;
  widgetBuilderComponentMetas: IWidgetBuilderComponentMeta[] | null;
}

export interface IBuilderComponent {
  id: number;
  widget_type_id: number;
  name: BuilderComponentName;
  slug: BuilderComponentSlug;
  content?: string;
}

export enum BuilderComponentName {
  eventBanner = "Event Top Banner",
  eventDetails = "Event Details",
  lineups = "Lineups",
  head2Head = "Statistics Head-2-Head",
  standings = "Standings",
  adBanner = "Banner",
  channels = "Channels",
}

export enum BuilderComponentSlug {
  eventBanner = "event_top_banner",
  eventDetails = "event_details",
  lineups = "lineups",
  lineupsPitch = "lineups_pitch",
  lineupsTable = "lineups_table",
  head2Head = "statistics_head_2_head",
  standings = "standings",
  topScorers = "statistics_top_scorers",
  trends = "trends",
  oddsComparison = "event_odds_comparison",
  matchStatistics = "match_statistics",
  adBanner = "banner",
  injuriesAndSuspensions = "injuries_and_suspensions",
  axSemantics = "ax_semantics",
  leagueStandings = 'league_standings_table',
  leagueOddsComparsion = 'league_odds_comparison',
  leagueOutrightOdds = 'league_outright_odds',
  channels = 'channels',
  nextRoundBanner = 'next_round_banner',
  featuredEvents = 'featured_events',
  matchSchedule = 'match_schedule',
  matchPrediction = 'match_prediction',
  leagueCountdown = 'countdown',
  complianceText = 'compliance_text',
  ctaButton = 'cta_button',
  contentOddsPreview = 'content_odds_preview',
  contentBettingTips = 'content_betting_tips',
  contentForm = 'content_form',
  contentFaq = 'content_faq',
  genericEventContent = 'generic_event_content',
  gameMinutes = 'game_minutes',
}

export enum BuilderComponentGroupSlug {
  overview = 'overview',
  stats = 'stats',
  odds = 'odds',
  news = 'news',
  general = 'general',
  header = 'header',
}

export interface ILineup {
  id: number;
  eventId: number;
  competitorId: number;
  formation: string;
  status: LineupStatus;
  lastUpdate: Date;
  kit: number;
  competitor: ICompetitor;
  lineupPlayers: ILineupPlayer[];
}

export interface ICoachData {
  age: number | null;
  countryofbirth: string | null;
  nameFull: string | null;
  nameFirst: string | null;
  nameLast: string | null;
  nationality: string | null;
}

export enum LineupStatus {
  expected = 'expected',
  official = 'official',
}

export interface ILineupPlayerType {
  id?: number; // Possible undefined
  name: string;
  lineupPlayers: ILineupPlayer[];
}

export interface ILineupPlayer {
  id: number;
  lineupId: number;
  competitorId: number;
  competitor?: ICompetitor;
  shirtNumber: number | null;
  pos: number | null;
  position: string;
  pitchPos?: string;
  goals: number;
  card: null | string;
  substIn: null | string;
  substOut: null | string;
  odds?: null | IOdds[];
  maxOdds?: null | IOdds;
}

export interface IChannel {
  id: number;
  name: string;
  logoUrl: string | null;
  slug: string;
  hasAffiliateLink?: number // is 1 or 0 as boolean
  channelType?: string;
  outFolder?: string | null;
  del?: string;
  createdAt?: string;
  updatedAt?: string;
  clientChannelData?: Object | null;
}

export interface IValueProps {
  valueProposition1: string;
  valueProposition2: string;
}

export enum EventPositions {
  home = 1,
  away = 2,
  homeSecond = 3,
  awaySecond = 4,
}

export enum EventTypes {
  event_1v1 = "event_1v1",
  event_2v2 = "event_2v2",
  event_n_v_n = "event_n_v_n",
  event_unknown = "event_unknown"
}

export interface IEvent {
  id: number;
  startTime: string,
  userStartTime: string,
  name: string,
  status: EventStatus,
  eventCompetitors?: IEventCompetitor[],
  tournamentStage?: ITournamentStage,
  tournamentStageId?: number,
  sportId?: number,
  gameMoment?: string | null,
}

export interface IMarket {
  id: number;
  objectType: string;
  objectId: number;
  marketTypeId: number;
  periodId: number;
  line: number;
  avgOddsDiff?: number;
}

export interface IMarketCompetitor {
  position: number;
  competitor: ICompetitor;
  competitorId?: number;
  objectType?: string;
  objectId?: number;
}

export interface IOdds {
  id: number;
  couponKey: string | null;
  marketId: number;
  odds: number;
  oddsPrev: number | null;
  outcomeId: number;
  providerId: number;
  sourceId: number;
  status: OddsStatus;
  provider: IProvider;
  outcome?: IOutcome;
  market?: IMarket;
}

export interface IOddsObj {
  id?: number;
  couponKey?: string | null;
  marketId?: number;
  odds?: number;
  oddsPrev: number | null;
  outcomeId?: number;
  providerId?: number;
  sourceId?: number;
  updatedAt: string | null;
  suspended: boolean;
  status: OddsStatus;
}

export enum OddsStatus {
  online = 'online',
  closed = 'closed',
  offline = 'offline',
  deleted = 'deleted',
}

export enum Vparam {
  home = 'home',
  away = 'away',
  total = 'total',
}

export interface IStreak {
  id: number,
  competitorId: number,
  competitionId: number,
  opponentId: number,
  vparam: Vparam | string,
  count: number,
  total: number,
  trText: string,
  competition: ICompetition,
  competitor: ICompetitor,
  opponent: ICompetitor | null,
}

export interface IBannerAd {
  id: number;
  bannerHeader: string | null;
  bannerBody: string | null;
  bannerHeaderMobile: string | null;
  bannerBodyMobile: string | null;
  title: string;
  active: boolean;
  widgetBuilderComponentId: number;
  created_at: string;
  updated_at: string;
}

export interface IBannerAdObj {
  id: number;
  widgetId: number;
  builderComponent: IBuilderComponent;
  builderComponentGroupId: number | null;
  builderComponentId: number;
  position: number;
  widgetBanner: IBannerAd | null;
}

export interface ISuspensionCharge {
  id: number;
  name: string;
}

export interface ISuspensions {
  id: number;
  playerId: number;
  teamId: number;
  competitionId: number;
  daysBanned: number;
  daysBannedLeft: number;
  lastUpdate: string;
  suspensionCharge?: ISuspensionCharge,
  player?: ICompetitor
}

interface IInjuryType {
  id: number;
  name: string;
  trName: string;
}

export interface IInjury {
  id: number,
  competitorId: number,
  startDate: string,
  endDate: string | null,
  expectedReturn: string|null,
  lastUpdate: string,
  priority: number,
  injuryType: IInjuryType|null,
  competitor: ICompetitor,
}

export interface IIsHeadToHead {
  id: number,
  sourceId: number | null,
  sportId: number,
  type: string,
  value: string
}

export interface IWidgetBackground {
  id: number,
  widgetId: number,
  sportId: number,
  filename: string,
  url: string
}

export enum outrightOddsCompetitorIconTypes {
  competitorLogo = 'competitor_logo',
}

export interface IWidgetBuilderComponentMeta {
  id: number,
  widgetBuilderComponentId: number,
  type: widgetBuilderComponentMetaTypes,
  value: string,
}

export enum widgetBuilderComponentMetaTypes {
  eventTopBanner1x2ProviderId = 'etb_1x2_provider_id',
  leagueCenterCountdownTitle = 'lc_cd_title',
  leagueCenterCountdownLink = 'lc_cd_link',
  leagueCenterCountdownLinkText = 'lc_cd_link_text'
}

export enum oddsFormats {
  decimal = 'decimal',
  fractional = 'fractional',
  american = 'american',
}

export interface IDropdownItem {
  value: number,
  name: string
}

export interface ITabItem {
  value: number;
  label: string;
}

export interface ISimpleProvider {
  id: number;
  slug: string;
}

export interface IWidgetData extends IWidget {
  clickableRows: boolean,
  showTeamLogos: boolean,
  clientId: number,
  id: number,
  languageId: number,
  linkTemplate: string | null,
  name: string,
  oddsFormat: oddsFormats,
  outLinkFolder: string | null,
  providerLogoTemplate: string,
  providerLogoType: string,
  status: string,
  theme: string,
  userId: number,
  widgetCompetitions: IWidgetCompetition[],
  competitionIds: number[],
  widgetProviders: ISimpleProvider[],
  widgetSports: number[],
  widgetStyles: IObjectStyle[],
  format: string,
  channel: IChannel | null,
  channelOutLinkFolder: string | null
}

export interface IWidgetAvailableMarket {
  value: number,
  title: string,
  marketTypeId: number,
  line: number
}

export interface IOutcomeNameGroup {
  title: string,
  names: string[],
  marketTypeId: number
}

export interface IMaxOddsObject extends Array<object> {
  [key: number]: IMaxOdd[]
}

export interface ITag {
  key: number,
  value: string
}

export interface IWidgetConfiguration {
  id: number,
  widgetId: number,
  key: string,
  value: string
}

export interface INextRoundData {
  eventId: number,
  eventName: string,
  untilLive: string,
  leftTeamLogo: string,
  rightTeamLogo: string,
  leftTeamName: string,
  rightTeamName: string,
  startTime: string,
  channels: IChannel[],
  preferredChannel: IChannel | null
  competitionName: string,
  status: string,
  gameScore: number[] | null,
  gameMoment: string | null,
}

export interface IClientChannelData {
  id: number,
  clientId: number,
  channelId: number,
  has_affiliate_link: number,
  json_data: string,
  data?: Object[]
}

export interface IProviderCompetition {
  providerId: number,
  widgetId: number,
  competitionId: number,
  provider: IProvider,
  backgroundUrl: string | null,
  background: string | null
}

export enum WidgetTypes {
  TYPE_ODDS_COMPARISON = 1,
  TYPE_OUTRIGHT_ODDS = 2,
  TYPE_MATCH_CENTER = 3,
  TYPE_CASINO_TOP_LIST = 4,
  TYPE_LIST_CREATOR = 5,
  TYPE_LEAGUE_CENTER = 6,
  TYPE_INTERNAL_EVENT_LIST = 7,
  TYPE_SINGLE_EVENT_ODDS_US = 8,
  TYPE_BETTING_CALCULATOR = 9,
  TYPE_TOP_LIST = 10,
  TYPE_OFFER_DISKS = 13,
}

export interface IOfferDiskData {
  id: number,
  name: string,
  lightLogoUrl: string,
  squareLogoUrl: string,
  themeColor: string,
  offerText: string,
  offerAmount: string,
  complianceText: string,
  slug: string
  outLink: string|null,
}

export interface IOfferDiskDataResponse {
  outLinkFolder: string,
  offerDisks: IOfferDiskData[]
}

export interface ITeam {
  logoUrl: string,
  trName: string,
  position: number
}

export interface IGameMinutesResponse {
  athletes: string[] | null,
  elapsed: number,
  elapsedPlus: number,
  icon: string,
  incidentName: string,
  order: number
  score: string | null,
  team: ITeam | null,
}

export interface IEventContent {
  id: number,
  clientId: number,
  contentTypeId: number,
  languageId: number,
  eventId: number,
  content: string,
  status: string
}
